module.exports = __webpack_public_path__ + "img/gia-logo.5b0419b.svg";